const MspPageLayout = ({ children }) => (
    <div className="msp-page-container">
        {children}
    </div>
);

export default MspPageLayout;
